export default "__VITE_ASSET__4b9fe6ab__"